import { px2rem, getCurrentPx, getScaleRatio, convertStylesToRem } from '@/utils/px2rem';

export default {
  methods: {
    /**
     * 将px转换为rem
     * @param {number} px - 像素值
     * @returns {string} - 转换后的rem值
     */
    px2rem(px) {
      return px2rem(px);
    },
    
    /**
     * 获取当前屏幕下的实际像素值
     * @param {number} px - 设计稿中的像素值
     * @returns {number} - 当前屏幕下的实际像素值
     */
    getCurrentPx(px) {
      return getCurrentPx(px);
    },
    
    /**
     * 获取当前屏幕的缩放比例
     * @returns {number} - 缩放比例
     */
    getScaleRatio() {
      return getScaleRatio();
    },
    
    /**
     * 批量转换样式对象
     * @param {Object} styles - 包含px值的样式对象
     * @returns {Object} - 转换后的样式对象
     */
    convertStyles(styles) {
      return convertStylesToRem(styles);
    },
    
    /**
     * 创建响应式样式对象
     * @param {Object} config - 样式配置对象
     * @returns {Object} - 响应式样式对象
     */
    createResponsiveStyles(config) {
      const styles = {};
      
      // 处理尺寸相关属性
      const sizeProps = ['width', 'height', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight'];
      sizeProps.forEach(prop => {
        if (config[prop] !== undefined) {
          styles[prop] = px2rem(config[prop]);
        }
      });
      
      // 处理间距相关属性
      const spacingProps = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 
                           'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'];
      spacingProps.forEach(prop => {
        if (config[prop] !== undefined) {
          styles[prop] = px2rem(config[prop]);
        }
      });
      
      // 处理字体相关属性
      if (config.fontSize !== undefined) {
        styles.fontSize = px2rem(config.fontSize);
      }
      if (config.lineHeight !== undefined) {
        styles.lineHeight = px2rem(config.lineHeight);
      }
      
      // 处理边框相关属性
      if (config.borderRadius !== undefined) {
        styles.borderRadius = px2rem(config.borderRadius);
      }
      if (config.borderWidth !== undefined) {
        styles.borderWidth = px2rem(config.borderWidth);
      }
      
      // 处理其他属性（直接复制）
      const otherProps = ['color', 'backgroundColor', 'borderColor', 'opacity', 'zIndex', 'position'];
      otherProps.forEach(prop => {
        if (config[prop] !== undefined) {
          styles[prop] = config[prop];
        }
      });
      
      return styles;
    }
  }
};
